import * as React from 'react';
export const TWSvg = React.forwardRef(function TWSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M2 0h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M2 0h7v7H0V2a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 4.5,
        cy: 3.5,
        r: 1.5,
        fill: '#FFF',
      }),
    ),
  );
});
TWSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TW = {
  category: 'flag',
  colorable: false,
  name: 'TW',
  svg: TWSvg,
};
